import { Button } from 'components';
import DateRangePicker from 'components/DatePicker/DateRangePicker';
import { useState } from 'react';
import dayjs from 'dayjs';

type Props = {
  periodOptions: string[];
  selectedPeriod: string;
  onPeriodChange: (value: string) => void;
  selectedDateRange: string[];
  onDateRangeChange: (value: string[]) => void;
};

export const PeriodSelector = ({
  periodOptions,
  selectedPeriod,
  onPeriodChange,
  selectedDateRange,
  onDateRangeChange
}: Props) => {
  const [isCustomRange, setIsCustomRange] = useState(false);

  const handlePeriodClick = (period: string) => {
    setIsCustomRange(false);
    onPeriodChange(period);
    
    // 버튼 클릭시 해당 기간에 맞는 범위 설정 (시작일 00:00:00, 종료일 23:59:59)
    const endDate = dayjs().format('YYYY-MM-DD') + ' 23:59:59';
    let startDate: string;
    
    switch (period) {
      case '1주':
      case '1 Week':
        startDate = dayjs().subtract(1, 'week').format('YYYY-MM-DD') + ' 00:00:00';
        break;
      case '1개월':
      case '1 Month':
        startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD') + ' 00:00:00';
        break;
      case '6개월':
      case '6 Months':
        startDate = dayjs().subtract(6, 'months').format('YYYY-MM-DD') + ' 00:00:00';
        break;
      default:
        startDate = dayjs().subtract(6, 'months').format('YYYY-MM-DD') + ' 00:00:00';
    }
    
    onDateRangeChange([startDate, endDate]);
  };

  const handleDateRangeChange = (value: string[] | ((prevState: string[]) => string[])) => {
    setIsCustomRange(true);
    if (typeof value === 'function') {
      // 함수형 업데이트의 경우
      const newValue = value(selectedDateRange);
      onDateRangeChange(newValue);
    } else {
      // 직접 값이 전달된 경우
      onDateRangeChange(value);
    }
  };

  return (
    <div className="flex items-center gap-2">
      {periodOptions.map((period) => (
        <Button
          key={period}
          text={period}
          onClick={() => handlePeriodClick(period)}
          type={selectedPeriod === period && !isCustomRange ? 'primary' : 'secondary'}
          size="medium"
        />
      ))}
      
      <div className="ml-4 flex items-center">
        <DateRangePicker
          label=""
          placeholder="Select date range"
          value={selectedDateRange}
          setValue={handleDateRangeChange}
          className="min-w-[300px]"
        />
      </div>
    </div>
  );
};